
     
	import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options , Vue  } from "vue-class-component";   
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import $ from "jquery"   
    import {  Prop   } from 'vue-property-decorator';   
    import MatriculaHistoricoService from   "@/service/v1/sigap/MatriculaHistoricoService"   
         
	  
    @Options({
        name: "InformacaoMatricula",
        components: {  CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar   },  
        emits: [  'historico-matricula-criada'],  
    }) 
    export default class InformacaoMatricula extends Vue {
          
        @Prop( ) readonly modal!: any  
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly matricula!: any

        public service = new MatriculaHistoricoService();  
 
        public dataPublicacao: any = null ; 
        public docPublicacao: any = null ;  
        public observacao: any  =  null ;  
        public titulo = 'Inserir Informação da Matrícula' ;
        public processando = false;   
           
        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public getdados(){   
            let dados:any = {};  
            dados.dataPublicacao = this.dataPublicacao;  
            dados.docPublicacao = this.docPublicacao;  
            dados.matriculaId = this.matricula.id;  
            dados.observacao = this.observacao;   
            return dados;
        }
 
        public sucesso(){  
            this.$emit("historico-matricula-criada", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
    
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar( dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  ); 
                    this.sucesso();  
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }   

    } 
